import { Component, Input, Output, EventEmitter } from '@angular/core';

// campfire
import { ConfigService, TrustpilotService } from '@campfire-nx/api';

export interface IDataInterface {
  type?: string,
  settings?: any
}

@Component({
  selector: 'app-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss']
})
export class ProductSummaryComponent {
  @Input() data!: IDataInterface;
  @Input() quote!: any;
  @Output() startQuoteEvent = new EventEmitter<string>();
  
  precision: number = 2;
  price: any = {
    currency: '$',
    amount: 0
  };
  arrang_fee!: any;

  constructor(
    private trustpilotService: TrustpilotService,
    private configService: ConfigService
  ) { }

  ngAfterViewInit():void {
    const trustpilotOptions = {
      trustboxTemplate: this.configService?.data?.trustpilot?.trustboxMicro,
      businessunitId: this.configService?.data?.trustpilot?.huddleBusinessId
    };

    this.trustpilotService.init(['trustbox-rating-1'], trustpilotOptions);
  }

  ngOnInit(): void {
    this.price.amount = this.quote.covers[0].premium.U.payable;
    
    this.arrang_fee = {
      'arrang_fee': Intl.NumberFormat(
        "en-AU", { 
          style: "currency", 
          currency: "AUD", 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2, 
          // @ts-expect-error NumberFormatOptions in TypeScript hasn't been updated to support 'trailingZeroDisplay' yet
          trailingZeroDisplay: "stripIfInteger" 
        }).format(this.quote.covers[0].premium?.U.extras?.arrang_fee?.payable)
    }
  }

  destinationHeading(destinations: string) {
    const locationArray = this.quote.human[destinations]
    let cardLabel = '';

    if (locationArray) {
      if (locationArray.length === 1) {
        cardLabel = "Your trip to " + locationArray;
      } else {
        cardLabel = this.data.settings.card.heading;
      }
    } else {
      cardLabel = this.data.settings.card.heading;
    }

    return cardLabel;
  }
}
